import { OnInit, Component, Input } from '@angular/core';
import { BaseService } from 'src/modules/base/shared/services/base.service';
import { ChartService } from '../../services/chart.service';

@Component({
    selector: 'app-widget-card',
    templateUrl: './widget-card.component.html',
    styleUrls: ['./widget-card.component.scss'],
    standalone: false
})
export class WidgetCardComponent implements OnInit {
    @Input() item: any;
    //@Input() fields: Array<any>; // we need to define field values.
    @Input() selection:any; // elementref where selected widget will be shown
    //data: any;
    public displayStatus:any = {};
    
    public isLoading: boolean = false;
    public _Count: any = {};
    public statsText: string = '';

    public chartData:any = false;
    public chartLabels: Array<any> = [];
    public chartOptions: any = {
        tooltips: {
            enabled: false
        },
        maintainAspectRatio: false,
        scales: {
            x: {
                grid: {
                    color: 'transparent',
                    zeroLineColor: 'transparent'
                },
                ticks: {
                    fontSize: 2,
                    fontColor: 'transparent',
                }

            },
            y: {
                display: false,
                ticks: {
                    display: false,
                    min: 1 - 5,
                    max: 34 + 5,
                }
            },
        },
        elements: {
            line: {
                tension: 0.00001,
                borderWidth: 1
            },
            point: {
                radius: 4,
                hitRadius: 10,
                hoverRadius: 4,
            },
        },
        legend: {
            display: false
        }
    };
    public chartColours: Array<any> = [
        {
            backgroundColor: 'white',
            borderColor: 'rgba(0,0,0,1)'
        }
    ];
    public chartLegend = false;
    public chartType : string = '';

  
    constructor(
        private baseService: BaseService,
        private chartService: ChartService,
        ) {
    }

    ngOnInit() {        
       this.loadAllData();
    }

    loadAllData(){
        if(this.item['current_count_datasource'] != undefined){
            this.loadCount(['current_count_datasource']);
        }

        if(this.item['past_count_datasource'] != undefined){
            this.loadCount(['past_count_datasource']);
        }
        if(this.item['chart_datasource'] != undefined){
            this.loadChartData();
        }
    }
    loadCount(key){
        
        var args = '';
        var filter = this.getFilter(key);

        if(this.item[key].args != undefined){
            args = this.item[key].args ;
        }


        this.isLoading = true;
        this.baseService.get(this.item[key].query_id, this.item[key].args, this.item[key].resource, this.item[key].application, filter).subscribe((res) => {
            if(res.errCode != -1 && res.resource != undefined && res.resource.length && res.resource[0].count_summary != undefined){
                this._Count[key] = res.resource[0].count_summary;
            }else{
                this._Count[key]  = 0;
            }

            this.isLoading = false;
            
        },error=>{
            this._Count[key]  = 0;
            this.isLoading = false;
        });
    }

    getFilter(key){
        var filter = '';
        if(this.item[key].filter != undefined && this.item[key].filter != ''){
            if(this.item[key].time != undefined ){
                filter = this.baseService.handleTimeRange(this.item[key].filter,this.item[key].time);
            }else{
                filter = this.item[key].filter;
            }
        }
        return filter; 
    }
   


    loadChartData(){
        this.chartService.loadChartData(this.item,(response)=>{
            if(response.chartData != undefined){
                this.chartData = response.chartData;
                console.log(" this.chartData", this.chartData);
                this.chartLegend =  response.chartLegend;
                this.chartType = response.chartType;
                this.chartLabels = response.labels;
            }else{
                this.chartData = false;
            }
        })
    }

    showLinkedWidget(type){
        if(this.displayStatus[type] == undefined){
            this.displayStatus[type] = true;
        }
        (this.selection.clear != undefined)?this.selection.clear():'';

        if(this.displayStatus[type]){
            if(this.item[type].linked_widget != undefined){
                if(this.selection && this.item[type].linked_widget.component != undefined && this.item[type].linked_widget.resource != undefined){
                    this.baseService.createComponent(this.item[type].linked_widget.component,this.selection,(response)=>{
                        var config:any = {};
                        config.filter = this.getFilter(type);
                        response.instance.resource = this.item[type].linked_widget.resource;
                        response.instance.config = config;
                        response.changeDetectorRef.detectChanges();
                    });
                }
            }
        }
        this.displayStatus[type] = !this.displayStatus[type];
        
    }
   
}